import { Warning } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from './ConfirmationDialog';

export default function InProcessStatusDialog({
  open,
  onClose,
  onSave,
  isLoading,
}) {
  const { t } = useTranslation('orders');

  return (
    <ConfirmationDialog
      open={open}
      onClose={onClose}
      onSave={onSave}
      isLoading={isLoading}
      icon={Warning}
      iconColor="warning"
      title={t('workOrderStatus.inProcess.title')}
      description={t('workOrderStatus.inProcess.description')}
      yesLabel={t('workOrderStatus.inProcess.yes')}
      noLabel={t('workOrderStatus.inProcess.noWait')}
    />
  );
}
